import React from "react"
import PropTypes from "prop-types"
import { Col, Container, Row } from "reactstrap"
import CaseCreationCardEnhanced from "../../components/CaseCreationCard/CaseCreationCardEnhanced"
import CaseListCardWithData from "../../components/CaseListCard/CaseListCardWithData"
import CreateEditCaseEnhanced from "../../components/CreateEditCase/CreateEditCaseEnhanced"
import PageBanner from "../../components/PageBanner"
import "./Overview.scss"

class Overview extends React.PureComponent {
  render() {
    return (
      <div className="Overview">
        <PageBanner
          children={
            <h1>{this.props.loading ? "" : this.props.facilityName}</h1>
          }
        />
        <Container fluid>
          <Row>
            <Col xl="1" lg="0" md="0" xs="0" />
            <Col xl="10" lg="12" md="12" xs="12">
              <Row>
                <Col lg="4" md="12" xs="12">
                  <CaseCreationCardEnhanced
                    creationComponent={CreateEditCaseEnhanced}
                  />
                </Col>
                <Col lg="4" md="6" xs="12">
                  <CaseListCardWithData listType="open" />
                </Col>
                <Col lg="4" md="6" xs="12">
                  <CaseListCardWithData listType="archived" />
                </Col>
              </Row>
            </Col>
            <Col xl="1" lg="0" md="0" xs="0" />
          </Row>
        </Container>
      </div>
    )
  }
}

Overview.propTypes = {
  loading: PropTypes.bool,
  facilityName: PropTypes.string,
}

Overview.defaultProps = {
  loading: false,
}

export default Overview
